var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.styles)},[_c('b-container',{staticClass:"text-center my-5"},[_c('b-row',[_c('b-col',{staticClass:"trusted-text mb-3"},[_vm._v(_vm._s(_vm.title))])],1),_vm._v(" "),_c('b-row',[_c('b-container',{staticClass:"text-center"},[_c('b-row',[_c('BrandsBlock',{attrs:{"brands":_vm.brands,"height":_vm.height}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }